<div class="heading">Filters
    <img src="../../../../assets/image/grievance/material-symbols_close.svg" id="closeimage" (click)="close()">
</div>
<hr>

<div class="filter_items">

    <p class="type_gvn">State</p>
    <div class="dropdown">
        <a class="btn  dropdown-toggle custom-dropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"
            (click)="focusSearchInput()">
            <ng-container>
                <span class="dropdown-label">{{ selectedStateName ? selectedStateName : 'Select State' }}
                </span>
            </ng-container>
        </a>
        <ul class="dropdown-menu campus-details">
            <li class="d-flex align-items-center">
                <input type="text" class="form-control form-search" placeholder="Enter State Name" #searchInputstate
                    (keyup)="stateSearch($event)" [(ngModel)]="stateQuery" />
            </li>
            <li class="list_campus">
                <ng-container *ngFor="let data of filteredStateDetails;  let i = index">
                    <ul class="overall_Detail" (click)="selectState(data?.stateName,data?.stateId)" (click)="stateData(data)"
                        [class.selected]="selectedStateID===data?.stateId">
                        <li class="campus_right"> {{data?.stateName}}</li>
                        <li>
                            <span *ngIf="selectedStateID===data?.stateId"><i class="fa fa-check right_check"></i></span>
                        </li>
                    </ul>
                </ng-container>
            </li>
        </ul>
    </div>


    <p class="type_gvn1">Zone</p>

    <div class="dropdown">
        <a class="btn  dropdown-toggle custom-dropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"
            (click)="focusSearchzoneInput()">
            <ng-container>
                <span class="dropdown-label">{{ selectedzoneName ? selectedzoneName : 'Select Zone' }}
                </span>
            </ng-container>
        </a>
        <ul class="dropdown-menu campus-details">
            <li class="d-flex align-items-center">
                <input type="text" class="form-control form-search" placeholder="Enter Zone Name" #searchInputzone
                    (keyup)="zoneSearch($event)" [(ngModel)]="zoneQuery" />
            </li>
            <li class="list_campus">
                <ng-container *ngFor="let data of filteredZoneDetails;  let i = index">
                    <ul *ngIf="data?.zoneName" class="overall_Detail" (click)="selectZone(data?.zoneName)" (click)="zoneData(data)"
                        [class.selected]="selectedzoneName===data?.zoneName" >
                        <li class="campus_right"> {{data?.zoneName }}</li>
                        <li>
                            <span *ngIf="selectedzoneName===data?.zoneName"><i
                                    class="fa fa-check right_check"></i></span>
                        </li>
                    </ul>
                </ng-container>
            </li>
        </ul>
    </div>

    <p class="type_gvn1">City</p>

    <div class="dropdown">
        <a class="btn  dropdown-toggle custom-dropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"
            (click)="focusSearchcityInput()">
            <ng-container>
                <span class="dropdown-label">{{ selectedcityName ? selectedcityName : 'Select City' }}
                </span>
            </ng-container>
        </a>
        <ul class="dropdown-menu campus-details">
            <li class="d-flex align-items-center">
                <input type="text" class="form-control form-search" placeholder="Enter City Name" #searchInputcity
                    (keyup)="citySearch($event)" [(ngModel)]="cityQuery" />
            </li>
            <li class="list_campus">
                <ng-container *ngFor="let data of filteredcityDetails;  let i = index">
                    <ul class="overall_Detail" (click)="selectCity(data?.cityName,data?.cityId)" (click)="cityData(data)"
                        [class.selected]="selectedcityId===data?.cityId">
                        <li class="campus_right"> {{data?.cityName}}</li>
                        <li>
                            <span *ngIf="selectedcityId===data?.cityId"><i class="fa fa-check right_check"></i></span>
                        </li>
                    </ul>
                </ng-container>
            </li>
        </ul>
    </div>

    <p class="type_gvn1">Campus</p>

    <div class="dropdown">
        <a class="btn  dropdown-toggle custom-dropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"
            (click)="focusSearchcampusInput()">
            <ng-container>
                <span class="dropdown-label">{{ selectedcampusName ? selectedcampusName : 'Select Campus' }}
                </span>
            </ng-container>
        </a>
        <ul class="dropdown-menu campus-details">
            <li class="d-flex align-items-center">
                <input type="text" class="form-control form-search" placeholder="Enter Campus Name" #searchInputcampus
                    (keyup)="campusSearch($event)" [(ngModel)]="campusQuery" />
            </li>
            <li class="list_campus">
                <ng-container *ngFor="let data of filteredcampusDetails;  let i = index">
                    <ul class="overall_Detail" (click)="selectCampus(data?.campusName,data?.campusId)" (click)="campusData(data)"
                        [class.selected]="selectedcampusId===data?.campusId">
                        <li class="campus_right"> {{data?.campusName}}</li>
                        <li>
                            <span *ngIf="selectedcampusId===data?.campusId"><i
                                    class="fa fa-check right_check"></i></span>
                        </li>
                    </ul>
                </ng-container>
            </li>
        </ul>
    </div>



    <!-- <p class="type_gvn1">Building</p>
    <div class="dropdown">
        <a class="btn  dropdown-toggle custom-dropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"
            (click)="focusSearchbuildingInput()">
            <ng-container>
                <span class="dropdown-label">{{ selectedbuildingName ? selectedbuildingName : 'Select' }}
                </span>
            </ng-container>
        </a>
        <ul class="dropdown-menu campus-details">
            <li class="d-flex align-items-center">
                <input type="text" class="form-control form-search" placeholder="Search..." #searchInputbuilding
                    (keyup)="buildingSearch($event)" [(ngModel)]="buildingQuery" />
            </li>
            <li class="list_campus">
                <ng-container *ngFor="let data of filteredbuildingDetails;  let i = index">
                    <ul class="overall_Detail" (click)="selectbuilding(data?.buildingName,data?.buildingId)"
                        [class.selected]="selectedbuildingId===data?.buildingId">
                        <li class="campus_right"> {{data?.buildingName}}</li>
                        <li>
                            <span *ngIf="selectedbuildingId===data?.buildingId"><i
                                    class="fa fa-check right_check"></i></span>
                        </li>
                    </ul>
                </ng-container>
            </li>
        </ul>
    </div> -->

</div>

<div class="Search_text">
    <button class="Search_btn" (click)="Search()">Search</button>
</div>